import type { Organization } from '@/overmind/effects/api/identity';
import type { GUID } from '@/overmind/effects/auth';

import { createGenericFetchMachine } from '../../machines/generic-fetch-machine';
import * as actions from './actions';

export type CurrentTenantId =
  | {
      type: 'SELECTED_TENANT';
      context: { tenantId: GUID; name: string; organizationName: string };
    }
  | { type: 'NO_TENANT_SELECTED' };

export type Tenant = {
  id: GUID;
  name: string;
  organizationName: string;
};
type TenantDetails =
  | { type: 'NOT_AVAILABLE' }
  | { type: 'AVAILABLE'; context: { tenants: Tenant[] } };

export type ApplicationAccess =
  | {
      type: 'NO_ACCESS';
    }
  | {
      type: 'HAS_ACCESS';
    }
  | {
      type: 'NOT_CHECKED';
    };

export const userOrganizations = createGenericFetchMachine<
  Organization[],
  string
>();

export type Tenants = {
  currentTenant: CurrentTenantId;
  availableTenants: TenantDetails;
  hasAccessToApplication: ApplicationAccess;
  tenantFromRoute:
    | { type: 'NONE' }
    | { type: 'ROUTED'; data: { tenantId: GUID } };
  userOrganizations: typeof userOrganizations;
};

const state: Tenants = {
  userOrganizations,
  currentTenant: { type: 'NO_TENANT_SELECTED' },
  availableTenants: { type: 'NOT_AVAILABLE' },
  hasAccessToApplication: { type: 'NOT_CHECKED' },
  tenantFromRoute: { type: 'NONE' }
};

export { state, actions };
